<template>
    <iframe class="integration-rule" :src="src" frameborder="0"></iframe>
</template>
<script>
    export default {
        data() {
            return {
                src: process.env.VUE_APP_INTEGRATION_RULE
            }
        },
        mounted(){
            console.log(this.src,1111)
        }
    }
</script>
<style lang="less" scoped>
    .integration-rule {
        flex: 1;
        width: 100%;
        height: 100%;
    }
</style>